module.exports = __webpack_public_path__ + "img/002朱晓琳.8fd7c8b8.jpg";